import React from 'react'
import Link from 'gatsby-link'

import HeaderSpacer from '../global/header-spacer'
import PortfolioFilter from '../header/portfolioFilter'

import PortfolioItem from './item'
import { Grid, GridItem } from '../grid'
import Navigation from '../navigation'

import GlobalPropsProvider from '../utils/stateProvider'

import globalState from '../../helpers/globalState'
import buildLink from '../../helpers/linkBuilder'

import Styles from '../../styles/components/portfolio.module.scss'

class PortfolioArchiveComponent extends React.PureComponent {
  constructor(props) {
    super(props)

    this.portfolio =
      this.props.data && this.props.data.items
        ? this.props.data.items.edges.map(edge => ({
            ...edge.node,
            categories: edge.node.portfolio_cat.map(cat =>
              globalState.state.portfolioCategories.find(
                gcat =>
                  (typeof cat === 'number' && cat === gcat.id) ||
                  (typeof cat === 'object' && cat.slug === gcat.slug)
              )
            ),
          }))
        : []
  }

  render() {
    const { filter, windowWide } = this.props
    const portfolio = this.portfolio.filter(project => {
      return (
        filter === null ||
        project.categories.filter(cat => cat.slug === filter).length > 0
      )
    })
    return (
      <div>
        <HeaderSpacer />
        {!windowWide && <PortfolioFilter inHeader={false} />}
        <Grid flip>
          {portfolio.map((project, index) => {
            const size = project.archive.size || '1x1'
            return (
              <GridItem key={`test_${project.slug}`} size={size}>
                <PortfolioItem
                  size={size}
                  image={project.archive.thumb}
                  permalink={buildLink({
                    slug: project.slug,
                    type: 'portfolio',
                    lang: project.lang,
                  })}
                  title={project.title}
                />
              </GridItem>
            )
          })}
        </Grid>
        <Navigation />
      </div>
    )
  }
}

export default GlobalPropsProvider(PortfolioArchiveComponent, state => ({
  filter: state.portfolioFilter,
  windowWide: state.windowWidth > 1200,
}))

// export default PortfolioArchiveComponent;



// WEBPACK FOOTER //
// ./src/components/portfolio/portfolioArchive.js